/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Directory_Ai_Tools_Packs_BuyInputs */

const en_directory_ai_tools_packs_buy = /** @type {(inputs: Directory_Ai_Tools_Packs_BuyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buy ${i?.price}`)
};

const zh_directory_ai_tools_packs_buy = /** @type {(inputs: Directory_Ai_Tools_Packs_BuyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`购买 ${i?.price}`)
};

/**
* | output |
* | --- |
* | "Buy {price}" |
*
* @param {Directory_Ai_Tools_Packs_BuyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_packs_buy = /** @type {((inputs: Directory_Ai_Tools_Packs_BuyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Packs_BuyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_packs_buy(inputs)
	return zh_directory_ai_tools_packs_buy(inputs)
});
export { directory_ai_tools_packs_buy as "directory.ai_tools.packs.buy" }